<template>
  <div
    class="flex flex-col md:grid md:grid-cols-3 md:divide-x divide-[#535353] mb-7 -mx-7"
  >
    <div class="px-6 py-2 md:py-0 md:px-8">
      <div class="uppercase font-semibold text-quaternary">Basic</div>
      <div class="text-orange-600 text-[30px] md:text-[57px]">$0</div>
      <div class="text-neutral-500 md:min-h-24">
        <div class="font-semibold text-[15px] text-balance">Free forever</div>
        <div class="text-[13px] mt-1 mb-2 md:mb-0">no strings attached</div>
      </div>
      <Button
        class="w-full"
        :disabled="
          currentSubscriptionPlan === null || !hasBillingManagePermission
        "
        @click="downgrade()"
      >
        <span v-if="currentSubscriptionPlan === null">Current plan</span>
        <span v-else>Downgrade</span>
      </Button>
      <ul class="text-neutral-300 leading-6 my-4 md:min-h-32">
        <li><Check class="inline-block w-4 h-4" /> 200 items / project</li>
        <li><Check class="inline-block w-4 h-4" /> 3 projects</li>
        <li><Check class="inline-block w-4 h-4" /> Unlimited members</li>
        <li><Check class="inline-block w-4 h-4" /> Unlimited guests</li>
        <li><Check class="inline-block w-4 h-4" /> 5MB file upload limit</li>
      </ul>
    </div>
    <div class="px-6 py-2 md:py-0 md:px-8 -order-1 md:order-none">
      <div class="uppercase font-semibold text-quaternary">PRO</div>
      <div class="text-orange-600 text-[30px] md:text-[57px]">$15</div>
      <div class="text-neutral-500 md:min-h-24">
        <div class="font-semibold text-[15px] text-balance">
          Per member / month billed annually
        </div>
        <div class="text-[13px] mt-1 mb-2 md:mb-0">$18 when billed monthly</div>
      </div>
      <Button
        class="w-full"
        :disabled="
          currentSubscriptionPlan?.subscription_type === 'pro' ||
          !hasBillingManagePermission
        "
        @click="goTo('workspaces_pro_2024_04')"
      >
        <span v-if="currentSubscriptionPlan?.subscription_type === 'pro'">
          Current plan
        </span>
        <span v-else-if="currentSubscriptionPlan?.subscription_type === 'team'"
          >Change to Pro</span
        >
        <span v-else>Upgrade to Pro</span>
      </Button>
      <ul class="text-neutral-300 leading-6 my-4 md:min-h-32">
        <li><strong>Everything in Basic plus</strong></li>
        <li>
          <Check class="inline-block w-4 h-4" /> Unlimited items / project
        </li>
        <li><Check class="inline-block w-4 h-4" /> Unlimited projects</li>
        <li><Check class="inline-block w-4 h-4" /> 100MB file upload limit</li>
        <li><Check class="inline-block w-4 h-4" /> Backup & Import project</li>
      </ul>
    </div>
    <div class="px-6 py-2 md:py-0 md:px-8 -order-2 md:order-none">
      <div class="uppercase font-semibold text-quaternary">TEAM</div>
      <div class="text-orange-600 text-[30px] md:text-[57px]">$25</div>
      <div class="text-neutral-500 md:min-h-24">
        <div class="font-semibold text-[15px] text-balance">
          Per member / month billed annually
        </div>
        <div class="text-[13px] mt-1 mb-2 md:mb-0">$30 when billed monthly</div>
      </div>
      <Button
        class="w-full"
        :disabled="
          currentSubscriptionPlan?.subscription_type === 'team' ||
          !hasBillingManagePermission
        "
        @click="goTo('workspaces_team_2024_04')"
      >
        <span v-if="currentSubscriptionPlan?.subscription_type === 'team'">
          Current plan
        </span>
        <span v-else>Upgrade to Team</span>
      </Button>
      <ul class="text-neutral-300 leading-6 my-4 md:min-h-32">
        <li><strong>Everything in Pro plus</strong></li>
        <li><Check class="inline-block w-4 h-4" /> API Acess</li>
        <li><Check class="inline-block w-4 h-4" /> Custom member Roles</li>
        <li><Check class="inline-block w-4 h-4" /> Priority support</li>
      </ul>
    </div>
  </div>
  <p class="text-gray-600 text-center text-sm tracking-wide">
    Part of a larger team? Contact
    <a href="mailtp:support@arcweave.com">support@arcweave.com</a> about our
    enterprise plan.
  </p>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useProtect } from '@/composables/useProtect.js';
import { Button } from '@ui/components/button';
import { Check } from 'lucide-vue-next';
import { SYS_PERMISSIONS } from '@/constants.js';

const store = useStore();

const { hasPermission: hasBillingManagePermission } = useProtect({
  permissions: [SYS_PERMISSIONS.SYS_BILLING_MANAGE],
});

const currentSubscriptionPlan = computed(
  () => store.getters['workspace/getCurrentSubscriptionPlan']
);

const emit = defineEmits(['goToCheckout', 'onDowngrade']);

const goTo = productId => {
  emit('goToCheckout', productId);
};

const downgrade = () => {
  emit('onDowngrade');
};
</script>
